<div class="season-ticket" *ngIf="!showPayment && !showDelivery">
  <h4 class="subtitle">{{ "EVENT.EXCLUSIVE_TICKETS" | translate }} - {{ selectedEvent?.eventName }}</h4>
  <ng-container *ngIf="selectedEvent.actions[0].id === subscriptionReservationActionId">
    <p class="description">{{ "EVENT.EXCLUSIVE_TICKETS_INFO" | translate }}</p>
    <ul class="description-list">
      <li>{{ "EVENT.EXCLUSIVE_TICKETS_INFO_1" | translate }}</li>
      <li>{{ "EVENT.EXCLUSIVE_TICKETS_INFO_2" | translate }}</li>
    </ul>
  </ng-container>

  <div class="container-checkbox" *ngIf="membershipBarcode || lastYearSeasonTicket">
    <label>
      <input
        type="checkbox"
        (change)="prefillDataForProfileOwner($event)"
      />
      <span class="checkmark"></span>
      {{ "EVENT.PREFILL_DATA" | translate }}
    </label>
  </div>

  <form [formGroup]="dataForm" (ngSubmit)="onSubmit()" class="form user-form">
    <div class="user-form-input mt-2 mb-2" [class.invalid]="dataForm.get('barcodeSeasonTicket')!.touched && dataForm.get('barcodeSeasonTicket')!.invalid">
      <label class="user-form-input-label" for="username">{{ "EVENT.ENTER_BARCODE_FOR_SEASON" | translate }} *</label>
      <input
        type="number"
        name="barcodeSeasonTicket"
        formControlName="barcodeSeasonTicket"
        class="form-control"
        data-name="data-form"
        id="barcodeSeasonTicket"
        (input)="this.errorMessage = ''"
        (focus)="openLoginModal()"
        (input)="limitInputLengthForNumberic($event)"
      />
    </div>

    <div class="user-form-input mt-5" [class.invalid]="dataForm.get('barcodeMembershipCard')!.touched && dataForm.get('barcodeMembershipCard')!.invalid">
      <label class="user-form-input-label" for="username">{{ "EVENT.ENTER_BARCODE_MEMBERSHIP" | translate }} *</label>
      <div class="user-form-membership-barcode">
        <input
          type="number"
          name="barcodeMembershipCard"
          formControlName="barcodeMembershipCard"
          class="form-control"
          data-name="data-form"
          id="barcodeMembershipCard"
          #barcodeMembershipCardInput
          (input)="this.errorMessage = ''"
          (focus)="openLoginModal()"
          (input)="limitInputLengthForNumberic($event)"
        />

        <!-- <button
          type="button"
          class="btn btn-secondary"
          (click)="prefillDataForProfileOwner()"
          *ngIf="membershipBarcode"
          >
          {{ "EVENT.MEMBERSHIP_CARD_FROM_PROFILE" | translate }}
        </button> -->
      </div>
    </div>

    <div class="container-checkbox terms-of-sale-container">
      <label> {{ "TERMS_OF_SALE.I_ACCEPT_SHORT" | translate }}
        <input type="checkbox" id="terms-of-sale-season-ticket" formControlName="termsOfSaleSeasonTicket" (change)="checkValue($event)">
        <span class="checkmark"></span>
      </label>
      <a target="_blank" routerLink="/terms-of-sale">{{ "TERMS_OF_SALE.TERMS_OF_SALE" | translate }}</a>
    </div>

    <span *ngIf="errorMessage" class="error-message">{{ errorMessage }}</span>

    <div class="button-container">
      <button class="btn btn-default" type="button" (click)="cancelOrder()">{{ "COMMON.CANCEL" | translate }}</button>
      <button class="btn btn-primary" type="submit">{{ "COMMON.CONTINUE" | translate }}</button>
    </div>
  </form>
</div>

<ng-container *ngIf="showDelivery">
  <app-delivery [orderIdFromParent]="orderId" (emitShowPaymentOnModalForMembership)="emitOnSubmitDeliveryData()"></app-delivery>
</ng-container>

<ng-container *ngIf="showPayment && order !== null && customerProfile">
  <h4 class="subtitle">{{ selectedEvent?.eventName }}</h4>

  <div *ngFor="let item of order.items">
    <div class="order-item">
      <p class="bold order-item-name">{{ item?.ticketOwner?.firstName }} {{ item?.ticketOwner?.lastName }} </p>
      <p>
        <span class="bold uppercase">{{ "TICKETS.SECTOR" | translate }}</span>: {{ item.sector }},
        <span class="bold">{{ "TICKETS.ROW" | translate }}</span>: {{ item.row }},
        <span class="bold">{{ "TICKETS.SEAT" | translate }}</span>: {{ item.seat }}
      </p>
    </div>
  </div>

  <app-cart-info-box
    [cart]="order"
    pageClass="order">
  </app-cart-info-box>

  <form class="user-form form" [formGroup]="deliveryForm" *ngIf="showDeliverySubscriptionWithMember && !order.isLocked">
    <div class="container-checkbox">
      <label for="deliverySameAs" class="user-form-input-label">{{ "EVENT.DELIVERY_SAME_AS_MEMBERSHIP_CARD" | translate }}
        <input
          type="checkbox"
          id="deliverySameAs"
          formControlName="deliverySameAs"
          (change)="setDeliveryWay()"
        />
        <span class="checkmark"></span>
      </label>
    </div>
  </form>

  <app-payment
    [redirectUrlFromParent]="redirectUrlFromParent"
    redirectErrorUrlFromParent="group-tickets-profile/transactionIncompleted"
    [hasPayment]="true"
    [customerProfile]="customerProfile"
    [orderId]="orderId"
    [orderInfo]=""
    (paymentStarted)="hideDeliveryFormOnPayment()"
    >
  </app-payment>
</ng-container>
